let RoutesData = [{
    "title": "Home",
    "route": ""
}, {
    "title": "Vendor",
    "route": "vendor"
}, {
    "title": "Technology",
    "route": "technology"
}, {
    "title": "Help",
    "route": "help"
}, {
    "title": "Contact",
    "route": "contact"
}, {
    "title": "Copyright",
    "route": "copyright"
}, {
    "title": "Terms",
    "route": "terms"
}, {
    "title": "Privacy",
    "route": "privacy"
}, {
    "title": "Security",
    "route": "security"
}, {
    "title": "Cookie",
    "route": "cookie"
}, {
    "title": "Disclaimer",
    "route": "disclaimer"
}, {
    "title": "PageNotFound",
    "route": "*"
}]

export default RoutesData
